import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const ICONS = "/iceholidays-assets/images/icons";

export default function SuccessView() {
  const navigate = useNavigate();

  return (
    <>
      <div className="customize-tour-form__success">
        <img className="customize-tour-form__success-icon" src={`${ICONS}/icon-success-check.svg`} alt="" aria-hidden="true" />
        <h2 className="customize-tour-form__success-heading">Your trip request is on its way!</h2>
        <p>
          Thank you for sharing your travel plans with us. Our travel specialists will review your
          preferences and get in touch within 1–2 business days to help create your perfect itinerary.
        </p>
        <p>
          In the meantime, feel free to explore more destinations and travel ideas with Golden Destinations.
        </p>
        <div className="customize-tour-form__success-actions">
          <Button
            type="primary"
            className="customize-tour-form__btn-continue"
            onClick={() => navigate("/web/ground-tour")}
          >
            Explore More Travel Ideas
          </Button>
        </div>
      </div>

      <div className="customize-tour-form__short-footer">
        <span>Copyright © 2026 Golden Destinations</span>
      </div>
    </>
  );
}
